import { $api } from './api';

export const useFaqQuery = () => $api.useQuery('get', '/faq', {});
